import { ContentType } from "@brookbush/database";

// Reverse of the canonical URL mapping used by the tutor prompt (contentUrl in
// packages/services) and by getRoutePrefix. Only the five public content types
// are recognized; anything else (external links, other internal routes) yields null.
const TYPE_BY_PREFIX: Record<string, ContentType> = {
	courses: ContentType.COURSE,
	articles: ContentType.ARTICLE,
	videos: ContentType.VIDEO,
	glossary: ContentType.GLOSSARY,
	certifications: ContentType.CERTIFICATION,
};

/**
 * Parses an internal content link href into its content type and slug.
 * @param href - The link href from the assistant's markdown
 * @returns The type + slug, or null when href is not an in-scope content link
 */
export const parseContentHref = (
	href?: string,
): { type: ContentType; slug: string } | null => {
	if (!href) return null;
	const match = href.match(/^\/([a-z]+)\/([^/?#]+)$/);
	if (!match) return null;
	const type = TYPE_BY_PREFIX[match[1]];
	return type ? { type, slug: match[2] } : null;
};
